<div class="flex flex-col items-center gap-1.5 w-4">
	<!-- Track: fills upward from the bottom -->
	<div
		class="relative w-full flex-1 rounded-sm overflow-hidden"
		style="background-color: var(--surface-container-high); min-height: 80px"
		[style.opacity]="opacity()"
	>
		<div
			class="absolute bottom-0 left-0 right-0 rounded-sm transition-[height] duration-2000 ease-linear"
			[style.height.%]="fillPercent"
			[style.background]="color"
			[style.opacity]="opacity()"
		></div>
	</div>

	<!-- Label -->
	<span class="text-[12px] tracking-widest uppercase" style="color: var(--on-surface)">{{
		label()
	}}</span>
</div>
